<ion-app [class]="customClass()">
  <ion-router-outlet id="menuContent"></ion-router-outlet>
</ion-app>
